<template>
    <!--
    In order to use <router/> link, we can't use html string for the popover content.
    This component is for the popover content (when hovering on the client/owner's) name.
    -->
    <div>
        <!-- address -->
        <div v-if="address !== ''" class="mb-3">
            <b>Address:</b>
            <br />
            {{ address }}
        </div>

        <!-- contacts -->
        <span v-if="owner.home && owner.home !== ''">
            <b>Home:</b>
            <a :href="`tel:${owner.home_country_code}${owner.home}`">
                {{ owner.home }}
            </a>
            <br />
        </span>

        <span v-if="owner.mobile && owner.mobile !== ''">
            <b>Mobile:</b>
            <a :href="`tel:${owner.mobile_country_code}${owner.mobile}`">
                {{ owner.mobile }}
            </a>
            <br />
        </span>

        <span v-if="owner.work && owner.work !== ''">
            <b>Work:</b>
            <a :href="`tel:${owner.work_country_code}${owner.work}`">
                {{ owner.work }}
            </a>
            <br />
        </span>

        <span v-if="owner.email && owner.email !== ''">
            <b>Email:</b>
            {{ owner.email }}
            <br />
        </span>

        <!-- pets-->
        <div v-if="patients.length > 0" class="mt-3">
            <b>Pets:</b>
            <br />
            <div v-if="USE_PATIENT_MODULE_VUE">
                <router-link
                    v-for="(patient, index) of patients"
                    :key="patient.id"
                    :to="{
                        name: 'patient_profile',
                        params: {
                            id: patient.encoded_id || patient.encodedId
                        }
                    }"
                    ><span v-if="index < patientLimit"
                        >{{ patient.name
                        }}<span v-if="index < patients.length - 1" class="comma"
                            >,
                        </span></span
                    >
                </router-link>
                <span v-if="patients.length > patientLimit">...</span>
            </div>
            <div v-else>
                <a
                    v-for="(patient, index) of patients"
                    :key="patient.id"
                    :href="`${CI_APPS}patient/patient/view/${patient.encoded_id}`"
                >
                    {{ patient.name
                    }}<span v-if="index < patients.length - 1" class="comma"
                        >,
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        owner: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            CI_APPS: process.env.CI_APPS,
            patientLimit: 10
        };
    },
    computed: {
        address() {
            let add = [
                this.owner.address,
                this.owner.city,
                this.owner.state,
                this.owner.zipcode
            ];

            let filteredAdd = add.filter(line => line !== "");
            return filteredAdd.join(", ");
        },
        patients() {
            return this.owner.active_patients || [];
        }
    }
};
</script>

<style scoped>
span.comma {
    font-weight: normal;
    color: #333;
}
</style>
